import _ from 'lodash';
import {
  FETCH_USER_MRD_IMPC_SELECTIONS_SUCCESS,
  SAVE_USER_MRD_IMPC_SELECTION_REQUEST,
  DELETE_USER_MRD_IMPC_SELECTION_REQUEST,
} from '../../../../user/redux/actions/types/UserActionTypes';
import { ENTERED_WIZARD } from '../../../common/redux/actions/types/SelectionCriteriaWizardActionTypes';
import postalOperatorsMapper from '../mappers/postalOperatorsMapper';
import {
  DEPARTURE_MRD_MAIL_PROCESSING_CENTER_CHECKED,
  DEPARTURE_MRD_POSTAL_OPERATOR_EXPANDED,
  DESELECT_ALL_DEPARTURE_MRD_MAIL_PROCESSING_CENTERS,
  RETRIEVE_OUTBOUND_MRD_POSTAL_OPERATOR_SUCCESS,
  SELECT_ALL_DEPARTURE_MRD_MAIL_PROCESSING_CENTERS,
  DEPARTURE_MRD_POSTAL_OPERATOR_EXPANDED_ADMIN,
} from '../actions/types/DeparturePostalOperatorActionTypes';
import filterIMPCCodesIfExistsInPostalOperators from '../filters/filterIMPCCodesIfExistsInPostalOperators';
import { SWITCH_DEPARTURE_ARRIVAL } from '../actions/types/PostalOperatorActionTypes';
import OperatorTypes from '../../../../common/redux/actions/types/OperatorTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';
import {
  DELETE_GLOBAL_SELECTION_MRDIMPC_REQUEST,
  SAVE_GLOBAL_SELECTION_MRDIMPC_REQUEST,
} from '../../../../admin/dashboard/redux/actions/types/AdminDashboardActionTypes';

export const initialState = {
  nodes: [],
  checkedMailProcessingCenters: [],
  expandedPostalOperators: [],
  expandedPostalOperatorsMrdAdmin: [],
  selections: [],
};

const allChildNodeValues = nodes =>
  nodes.map(node => node.children.map(mPC => mPC.value))
    .reduce((initial, impcCodes) => initial.concat(impcCodes));

const handleUserIMPCSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, { name: action.payload.selectionName });
  const newSelection = {
    name: action.payload.selectionName,
    direction: null,
    impcCodes: action.payload.selectedIMPCCodes,
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleAdminIMPCSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, { name: action.payload.selectionName });
  const newSelection = {
    name: action.payload.selectionName,
    direction: null,
    impcCodes: action.payload.selectedIMPCCodes,
    scope: 'GLOBAL',
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleUserIMPCSelectionDeleteRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter(item => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleAdminMrdImpcSelectionDeleteRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter(item => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

export const departurePostalOperatorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_MRD_IMPC_SELECTIONS_SUCCESS:
      if (action.payload.postalOperatorType === OperatorTypes.DEPARTURE) {
        return {
          ...state,
          selections: [...action.payload.selections]
            .map(selection => ({
              ...selection,
              name: selection.name === 'LAST_SELECTION' ? 'Your last selection' : selection.name,
            }))
            .sort((a, b) => a.name.localeCompare(b.name)),
        };
      }
      return state;
    case RETRIEVE_OUTBOUND_MRD_POSTAL_OPERATOR_SUCCESS:
      return {
        ...state,
        nodes: postalOperatorsMapper(action.payload),
        isLoading: false,
      };
    case DEPARTURE_MRD_MAIL_PROCESSING_CENTER_CHECKED:
      return {
        ...state,
        checkedMailProcessingCenters: filterIMPCCodesIfExistsInPostalOperators(
          action.checkedMailProcessingCenters,
          state.nodes,
          action.reportDefinition,
        ),
      };
    case DEPARTURE_MRD_POSTAL_OPERATOR_EXPANDED:
      return {
        ...state,
        expandedPostalOperators: [...action.expandedPostalOperators],
      };
    case DEPARTURE_MRD_POSTAL_OPERATOR_EXPANDED_ADMIN:
      return {
        ...state,
        expandedPostalOperatorsMrdAdmin: [...action.expandedPostalOperatorsMrdAdmin],
      };
    case SELECT_ALL_DEPARTURE_MRD_MAIL_PROCESSING_CENTERS:
      return {
        ...state,
        checkedMailProcessingCenters: allChildNodeValues(action.payload.nodes),
      };
    case DESELECT_ALL_DEPARTURE_MRD_MAIL_PROCESSING_CENTERS:
      return {
        ...state,
        checkedMailProcessingCenters: [],
      };
    case ENTERED_WIZARD:
      return initialState;
    case SAVE_USER_MRD_IMPC_SELECTION_REQUEST:
      return handleUserIMPCSelectionRequest(action, state);
    case SAVE_GLOBAL_SELECTION_MRDIMPC_REQUEST:
      return handleAdminIMPCSelectionRequest(action, state);
    case DELETE_USER_MRD_IMPC_SELECTION_REQUEST:
      return handleUserIMPCSelectionDeleteRequest(action, state);
    case DELETE_GLOBAL_SELECTION_MRDIMPC_REQUEST:
      return handleAdminMrdImpcSelectionDeleteRequest(action, state);
    case SWITCH_DEPARTURE_ARRIVAL:
      return {
        ...state,
        ...action.payload.arrival,
      };
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};
